module.exports = __webpack_public_path__ + "0fc816cbaaddf3d5b8c6b00c4acddf58.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/media/fonts/Poppins/Poppins-SemiBoldItalic.ttf
// module id = 1255
// module chunks = 0